import { gql } from '@apollo/client';

export const FINAL_STUDENT_DETAILS = gql`
  query finalStudentDetails($where: FinalStudentDetailsWhereInput!) {
    finalStudentDetails(where: $where) {
      status
      sliitID
      waiID
      remarks
      initialRegistrationFeePaid
      agreementURLs
      ordinaryLevelCertificateURLs
      nicCopyURLs
      passportSizePhotoURLs
      passportOrBirthCertificateURLs
      educationalCertificatesURLs
    }
  }
`;

export const STUDENT_PROFILE_ACADEMIC_INFORMATION = gql`
  query studentProfileAcademicInformation($where: StudentProfileAcademicInformationWhereInput!) {
    studentProfileAcademicInformation(where: $where) {
      studentsAttendance {
        batchSubjectConfigurationId
        attendance
        grade
        externalEngagementRequestsCount
        medicalRequestsCount
        halfDaysCount
      }
    }
  }
`;

export const STUDENT_FAMILIARIZATION_INTERVIEW = gql`
  query student_familiarization_interview($where: student_familiarization_interview_bool_exp) {
    student_familiarization_interview(where: $where) {
      learningPreferences
      makingFriendsAtCahm
      familyBackground
      doubtsFears
      roleModel
      studentId
    }
  }
`;

export const STUDENT_ID_FOR_FAMILIARIZATION_INTERVIEW_FORM = gql`
  query student_id_for_familiariazation_interview_form($where: student_admin_editable_information_bool_exp) {
    student_admin_editable_information(where: $where) {
      id
    }
  }
`;

export const STUDENT_PERFORMANCE = gql`
  subscription student_performance($where: student_performance_bool_exp, $order_by: [student_performance_order_by!]) {
    student_performance(where: $where, order_by: $order_by) {
      category
      created_at
      description
      id
      title
      status
      user {
        firstName
        lastName
        middleName
      }
    }
  }
`;

export const DELETE_STUDENT_PERFORMANCE = gql`
  mutation delete_student_performance($where: student_performance_bool_exp!) {
    delete_student_performance(where: $where) {
      affected_rows
    }
  }
`;

export const STUDENT_PROFILE = gql`
  query studentProfile($where: student_bool_exp) {
    student(where: $where) {
      id
      regNumber
      firstName
      middleName
      lastName
      email
      mobileNo
      passportSizePhotoURLs
      waiID
      sliitID
      createdAt
      dateOfBirth
      preferredName
      parentOrGuardianName
      parentOrGuardianLandLineNo
      parentOrGuardianMobileNo
      bloodType
      illnessesDisabilities
      status
      nicCopyURLs
      agreementURLs
      isContactParent
      ordinaryLevelCertificateURLs
      passportOrBirthCertificateURLs
      passportSizePhotoURLs
      educationalCertificatesURLs
      profileUploadedPhotoURLs
      remarks
      student_courses(where: { active: { _eq: true } }) {
        course {
          name
          id
        }
      }
      student_batch_histories {
        id
        endDate
        batch_class {
          id
          batch {
            id
            name
            batch_subject_configurations {
              id
              subject {
                code
                name
              }
            }
            course {
              id
              code
              name
              course_semesters(order_by: [{ semester: asc }]) {
                semester
                weeksPerSemester
                batch_subject_configurations {
                  id
                  subject {
                    code
                    name
                  }
                }
              }
            }
            year
            intake {
              name
            }
            academic_calendar_items {
              semester
              startDate
              endDate
            }
          }
          name
        }
      }
    }
  }
`;

export const STUDENT_EMAIL_CHECK = gql`
  query student_email_check($where: student_bool_exp) {
    student(where: $where) {
      email
    }
  }
`;

export const STUDENT_NIC_CHECK = gql`
  query student_nic_check($where: student_bool_exp) {
    student(where: $where) {
      nicNo
    }
  }
`;
export const STUDENT = gql`
  query student($where: student_bool_exp) {
    student(where: $where) {
      id
      regNumber
      firstName
      middleName
      lastName
      preferredName
      dateOfBirth
      mobileNo
      landLineNo
      email
      passportNo
      nicNo
      permanentStreetAddress1
      permanentStreetAddress2
      permanentCity
      permanentCountry
      sameAsPermanentAddress
      permanentProvince
      permanentDistrict
      gender
      nationality
      isContactParent
      parentOrGuardianName
      parentOrGuardianLandLineNo
      parentOrGuardianMobileNo
      parentOrGuardianStreetAddress1
      parentOrGuardianStreetAddress2
      parentOrGuardianCity
      parentOrGuardianCountry
      parentOrGuardianProvince
      parentOrGuardianDistrict
      spokenLanguages
      referredVia
      status
      whatsapp_number
      postal_id
      education_qualifications {
        id
        name
        schoolOrInstitute
        yearOfCompletion
        gradings
      }
      employment_experiences {
        id
        startDate
        endDate
        position
        company
        duties
        references
      }
      student_courses {
        id
        intakeId
        registeredYear
        student {
          student_batch_histories {
            batch_class {
              batch {
                courseId
                intakeId
                year
              }
            }
          }
        }
        course {
          id
        }
        intake {
          id
        }
        registeredYear
        active
      }
      student_batch_classes_batch_classes {
        batch_class {
          name
          batch {
            name
            year
            intake {
              name
            }
          }
        }
      }
    }
  }
`;

export const STUDENT_LIST = gql`
  subscription studentList($where: student_bool_exp, $order_by: [student_order_by!], $limit: Int, $offset: Int) {
    student(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      regNumber
      firstName
      middleName
      lastName
      waiID
      sliitID
      email
      student_courses {
        id
        active
        registeredYear
        course {
          id
          name
          code
        }
        intake {
          name
        }
      }
      status
      student_batch_classes_batch_classes {
        batch_class {
          name
          batch {
            name
            year
            intake {
              name
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_FINAL_STUDENT_DETAILS = gql`
  mutation updateFinalStudentDetails(
    $where: UpdateFinalStudentDetailsWhereInput!
    $data: UpdateFinalStudentDetailsInput!
  ) {
    updateFinalStudentDetails(where: $where, data: $data) {
      regNumber
    }
  }
`;

export const UPDATE_STUDENT_ALTERNATIVE = gql`
  mutation updateStudentAlternative($where: student_bool_exp!, $_set: student_set_input) {
    update_student(where: $where, _set: $_set) {
      returning {
        status
        remarks
      }
      affected_rows
    }
  }
`;
export const STUDENT_FOR_BATCH = gql`
  query student_for_batch($where: student_for_batch_bool_exp) {
    student_for_batch(where: $where) {
      id
      firstName
      lastName
      regNumber
      gender
      sliitID
      student_batch_classes_batch_classes {
        batchClassId
        batch_class {
          id
          batchId
        }
      }
      student_batch_histories {
        id
        batchClassId
        batch_class {
          id
          name
          batch {
            id
            name
          }
        }
        endDate
        student_batch_history_subjects {
          subjectId
          completed
        }
      }
    }
  }
`;

export const UPDATE_STUDENT = gql`
  mutation updateStudent($where: UpdateStudentWhereInput!, $data: UpdateStudentInput!) {
    updateStudent(where: $where, data: $data) {
      regNumber
      status
    }
  }
`;

export const UPDATE_STUDENT_INITIAL_TOUR_FOLLOWED = gql`
  mutation updateStudentInitialTourFollowed($_set: current_student_set_input, $where: current_student_bool_exp!) {
    update_current_student(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

export const CURRENT_STUDENT = gql`
  query currentStudent($where: current_student_course_bool_exp) {
    current_student {
      id
      regNumber
      firstName
      lastName
      middleName
      preferredName
      firebaseUID
      email
      gender
      status
      initialTourFollowed
      student_familiarization_form {
        id
      }
      exit_interview_answer {
        id
      }
      current_student_courses(where: $where) {
        courseId
        intakeId
        registeredYear
      }
    }
  }
`;

export const CURRENT_STUDENT_ROUTES = gql`
  query currentStudentRoutes {
    current_student_routes_route {
      current_user_route {
        id
        name
        componentName
        path
        iconName
        dummy
        showInMenu
        order
        global
        parentId
        current_user_route_parent {
          name
          id
        }
      }
    }
  }
`;

export const STUDENTS_FOR_ATTENDANCE = gql`
  query studentsForAttendance(
    $where: student_timetable_item_bool_exp
    $leaveStartDate: timestamptz
    $leaveEndDate: timestamptz
  ) {
    student_timetable_item(where: $where) {
      id
      studentId
      studentFirstName
      studentLastName
      preferredName
      regNumber
      sliitID
      student_requests(where: { status: { _eq: approved } }) {
        student_medical_requests(
          where: { _and: [{ leaveStartDate: { _gte: $leaveStartDate } }, { leaveStartDate: { _lte: $leaveEndDate } }] }
        ) {
          id
        }
        student_external_engagement_requests {
          id
        }
      }
    }
  }
`;

export const REGISTER_STUDENT = gql`
  mutation registerStudent($data: RegisterStudentInput!) {
    registerStudent(data: $data) {
      regNumber
    }
  }
`;

export const UPDATE_STUDENT_EDITABLE_INFORMATION = gql`
  mutation update_student_self_editable_information(
    $_set: student_self_editable_information_set_input
    $where: student_self_editable_information_bool_exp!
  ) {
    update_student_self_editable_information(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

export const STUDENT_DOCUMENT_UPLOAD_URLS = gql`
  query studentDocumentUploadURLs($data: StudentDocumentUploadURLsInput!) {
    studentDocumentUploadURLs(data: $data) {
      id
      url
    }
  }
`;

export const STUDENTS_FOR_RESULT_SHEET = gql`
  query studentsForResultSheet($where: StudentsWithAttendanceWhereInput!) {
    studentsWithAttendance(where: $where) {
      id
      waiID
      firstName
      lastName
      regNumber
      attendance
      preferredName
      sliitID
    }
  }
`;

export const UPDATE_STUDENT_STATUS = gql`
  mutation update_student_admin_editable_information(
    $_set: student_admin_editable_information_set_input
    $where: student_admin_editable_information_bool_exp!
  ) {
    update_student_admin_editable_information(_set: $_set, where: $where) {
      affected_rows
    }
  }
`;

export const STUDENT_FAMILIARIZATION_FORM_LIST = gql`
  query student_familiarization_formList($where: student_familiarization_form_bool_exp) {
    student_familiarization_form(where: $where) {
      id
      created_at
    }
  }
`;

export const STUDENT_FAMILIARIZATION_INTERVIEW_LIST = gql`
  query student_familiarization_interviewList($where: student_familiarization_interview_bool_exp) {
    student_familiarization_interview(where: $where) {
      id
      created_at
      createdUser {
        firstName
        lastName
      }
    }
  }
`;

export const STUDENT_EXIT_INTERVIEW_ANSWER_LIST = gql`
  query exit_interview_answerList($where: exit_interview_answer_bool_exp) {
    exit_interview_answer(where: $where) {
      id
      created_at
    }
  }
`;

export const WITHDRAWN_REQUESTS = gql`
  subscription withdrawn_request {
    withdrawn_request {
      id
      regNumber
      firstName
      lastName
      mobileNo
      remarks
      attendanceStudentId
      student_courses {
        student {
          student_batch_histories(where: { endDate: { _is_null: true } }) {
            batch_class {
              batch {
                name
                course {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const STUDENTS_FOR_CLASS_LIST = gql`
  query studentsForClassList($where: student_bool_exp) {
    student(where: $where) {
      id
      firstName
      middleName
      lastName
      regNumber
      waiID
      student_batch_classes_batch_classes {
        batch_class {
          name
          batchId
        }
      }
    }
  }
`;

export const STUDENTS_FOR_CERTIFICATE_REQUESTS = gql`
  query studentsForCertificateRequests($where: student_for_batch_bool_exp) {
    student_for_batch(where: $where) {
      id
      firstName
      middleName
      lastName
      regNumber
      waiID
    }
  }
`;

export const STUDENT_STAT = gql`
  query studentStat($where: student_bool_exp) {
    student_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;
